document.addEventListener('DOMContentLoaded', function () {
  const servingCache = {};

  let currentProductHandle = '';
  let currentServingData = null;

  function getHandleFromUrl(url) {
    if (!url) return '';

    const match = String(url).match(/\/products\/([^/?#]+)/);

    return match ? match[1] : '';
  }

  function getAlgoliaCard(button) {
    if (!button) return null;

    return button.closest(
      '.ais-hit, .ais-hits--item, .ais-Hits-item, article, li'
    );
  }

  function getHandleFromAlgoliaButton(button) {
    if (!button) return '';

    /*
     * Algolia places the exact Shopify handle directly on the
     * surrounding result card as data-product-handle.
     */
    const card = button.closest(
      '.ais-hit.ais-product[data-product-handle], ' +
      '.ais-hit[data-product-handle], ' +
      '[data-product-handle]'
    );

    if (card) {
      const handle = String(
        card.getAttribute('data-product-handle') || ''
      ).trim();

      if (handle) {
        return handle;
      }
    }

    /*
     * Fallback for any result card that only contains
     * a normal Shopify product link.
     */
    const fallbackCard = getAlgoliaCard(button);

    if (!fallbackCard) return '';

    const productLink = fallbackCard.querySelector(
      'a[href*="/products/"]'
    );

    return productLink
      ? getHandleFromUrl(
          productLink.getAttribute('href') ||
          productLink.href
        )
      : '';
  }

  function getHandleFromProductPage() {
    return getHandleFromUrl(window.location.pathname);
  }

  function singularizeForm(form) {
    const normalized = String(form || '')
      .toLowerCase()
      .trim();

    const forms = {
      capsules: 'capsule',
      capsule: 'capsule',
      tablets: 'tablet',
      tablet: 'tablet',
      softgels: 'softgel',
      softgel: 'softgel',
      'soft gels': 'softgel',
      'soft gel': 'softgel',
      gummies: 'gummy',
      gummy: 'gummy',
      chewables: 'chewable',
      chewable: 'chewable',
      'soft chews': 'soft chew',
      'soft chew': 'soft chew',
      pills: 'pill',
      pill: 'pill'
    };

    return forms[normalized] || normalized || 'piece';
  }

  function pluralizeForm(form, quantity) {
    const singular = singularizeForm(form);

    if (Number(quantity) === 1) {
      return singular;
    }

    if (singular === 'gummy') {
      return 'gummies';
    }

    if (singular === 'soft chew') {
      return 'soft chews';
    }

    return singular + 's';
  }

  function inferFormFromText(text) {
    const lower = String(text || '').toLowerCase();

    if (lower.includes('soft chew')) return 'soft chew';
    if (lower.includes('softgel')) return 'softgel';
    if (lower.includes('soft gel')) return 'softgel';
    if (lower.includes('gumm')) return 'gummy';
    if (lower.includes('chewable')) return 'chewable';
    if (lower.includes('capsule')) return 'capsule';
    if (lower.includes('tablet')) return 'tablet';
    if (lower.includes('pill')) return 'pill';

    return 'piece';
  }

  function normalizeServingData(data) {
    if (!data) return null;

    const quantity = Number(data.serving_quantity);
    const form = singularizeForm(data.serving_form);

    if (
      !Number.isInteger(quantity) ||
      quantity < 1 ||
      !form ||
      form === 'piece'
    ) {
      return null;
    }

    return {
      piecesPerServing: quantity,
      form: form
    };
  }

  function readServingScript(container) {
    if (!container) return null;

    const script = container.querySelector(
      '[data-supp-serving-data]'
    );

    if (!script) return null;

    try {
      return JSON.parse(script.textContent.trim());
    } catch (error) {
      console.warn(
        'SuppLovin: Unable to read serving metafields.',
        error
      );

      return null;
    }
  }

  function readServingDataFromCurrentPage(handle) {
    const rawData = readServingScript(document);

    if (!rawData) return null;

    if (
      handle &&
      rawData.handle &&
      rawData.handle !== handle
    ) {
      return null;
    }

    return {
      rawData: rawData,
      servingData: normalizeServingData(rawData)
    };
  }

  function fetchServingData(handle) {
    if (!handle) {
      return Promise.resolve({
        rawData: null,
        servingData: null,
        productText: ''
      });
    }

    if (servingCache[handle]) {
      return Promise.resolve(servingCache[handle]);
    }

    const currentPageData =
      readServingDataFromCurrentPage(handle);

    if (currentPageData) {
      const currentPageResult = {
        rawData: currentPageData.rawData,
        servingData: currentPageData.servingData,
        productText:
          document.title + ' ' + document.body.innerText
      };

      servingCache[handle] = currentPageResult;

      return Promise.resolve(currentPageResult);
    }

    return fetch(
      '/products/' + encodeURIComponent(handle),
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html'
        }
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to load product page');
        }

        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const productDocument = parser.parseFromString(
          html,
          'text/html'
        );

        const rawData = readServingScript(productDocument);

        const result = {
          rawData: rawData,
          servingData: normalizeServingData(rawData),
          productText:
            productDocument.title +
            ' ' +
            productDocument.body.innerText
        };

        servingCache[handle] = result;

        return result;
      })
      .catch(function (error) {
        console.warn(
          'SuppLovin: Unable to load serving information.',
          error
        );

        return {
          rawData: null,
          servingData: null,
          productText: ''
        };
      });
  }

  function ensureServingMessage() {
    const customizeArea = document.getElementById(
      'pack-customize-area'
    );

    if (!customizeArea) return null;

    let message = document.getElementById(
      'pack-serving-message'
    );

    if (!message) {
      message = document.createElement('div');
      message.id = 'pack-serving-message';
      message.className = 'pack-serving-message';

      const quantityRow = customizeArea.querySelector(
        '.pack-quantity-row'
      );

      if (quantityRow) {
        customizeArea.insertBefore(message, quantityRow);
      } else {
        customizeArea.insertBefore(
          message,
          customizeArea.firstChild
        );
      }
    }

    return message;
  }

  function setLoadingState() {
    const select = document.getElementById('pack-quantity');
    const message = ensureServingMessage();

    if (message) {
      message.innerHTML = `
        <strong>Checking the recommended serving…</strong>
        <span>Please wait a moment.</span>
      `;
    }

    if (select) {
      select.innerHTML = `
        <option value="">Loading serving options…</option>
      `;

      select.disabled = true;
    }
  }

  function setUnavailableState(productText) {
    const select = document.getElementById('pack-quantity');
    const message = ensureServingMessage();

    const customizeArea = document.getElementById(
      'pack-customize-area'
    );

    const quantityLabel = customizeArea
      ? customizeArea.querySelector(
          'label[for="pack-quantity"]'
        )
      : null;

    const note = customizeArea
      ? customizeArea.querySelector(
          '.pack-customize-note'
        )
      : null;

    const modalText = [
      productText || '',
      document.querySelector('#pack-modal')?.innerText || '',
      document.querySelector('.pack-modal')?.innerText || '',
      document.querySelector('#pack-product-title')?.innerText || '',
      document.querySelector('.pack-product-title')?.innerText || '',
      document.querySelector('[data-pack-product-title]')?.innerText || ''
    ].join(' ');

    const inferredForm = inferFormFromText(modalText);

    const displayForm =
      inferredForm === 'piece'
        ? 'item'
        : inferredForm;

    currentServingData = null;

    if (message) {
      message.innerHTML = `
        <strong>Serving size could not be confirmed</strong>
        <span>
          Please check the product label for the recommended
          serving size.
        </span>
      `;
    }

    if (quantityLabel) {
      quantityLabel.textContent =
        'How many ' +
        pluralizeForm(displayForm, 2) +
        ' would you like to add to your Daily Pack?';
    }

    if (note) {
      note.textContent =
        'Choose the number of physical ' +
        pluralizeForm(displayForm, 2) +
        ' to include in each Daily Pack.';
    }

    if (select) {
      select.innerHTML =
        '<option value="">Select quantity</option>';

      for (
        let quantity = 1;
        quantity <= 10;
        quantity += 1
      ) {
        const option = document.createElement('option');

        option.value = String(quantity);
        option.textContent =
          quantity +
          ' ' +
          pluralizeForm(displayForm, quantity);

        select.appendChild(option);
      }

      select.disabled = false;
    }
  }

  function buildServingOptions(servingData) {
    const select = document.getElementById('pack-quantity');
    const message = ensureServingMessage();

    const customizeArea = document.getElementById(
      'pack-customize-area'
    );

    const quantityLabel = customizeArea
      ? customizeArea.querySelector(
          'label[for="pack-quantity"]'
        )
      : null;

    const note = customizeArea
      ? customizeArea.querySelector(
          '.pack-customize-note'
        )
      : null;

    if (!select || !servingData) return;

    const piecesPerServing =
      Number(servingData.piecesPerServing);

    const dosageForm = servingData.form;

    currentServingData = {
      piecesPerServing: piecesPerServing,
      form: dosageForm
    };

    if (message) {
      message.innerHTML = `
        <strong>
          1 serving for this supplement is
          ${piecesPerServing}
          ${pluralizeForm(
            dosageForm,
            piecesPerServing
          )}.
        </strong>
        <span>
          The recommended quantity is selected below.
        </span>
      `;
    }

    if (quantityLabel) {
      quantityLabel.textContent =
        'How many ' +
        pluralizeForm(dosageForm, 2) +
        ' would you like to add to your Daily Pack?';
    }

    if (note) {
      note.textContent =
        'Choose the number of physical ' +
        pluralizeForm(dosageForm, 2) +
        ' to include in each Daily Pack.';
    }

    select.innerHTML =
      '<option value="">Select quantity</option>';

    for (
      let quantity = 1;
      quantity <= 10;
      quantity += 1
    ) {
      const option = document.createElement('option');

      option.value = String(quantity);

      option.textContent =
        quantity +
        ' ' +
        pluralizeForm(dosageForm, quantity) +
        (quantity === piecesPerServing
          ? ' — Recommended'
          : '');

      option.dataset.servings =
        quantity % piecesPerServing === 0
          ? String(quantity / piecesPerServing)
          : '';

      option.dataset.pieces = String(quantity);

      select.appendChild(option);
    }

    select.value = String(piecesPerServing);
    select.disabled = false;
  }

  function loadServingOptions(handle) {
    if (!handle) {
      setUnavailableState('');
      return;
    }

    currentProductHandle = handle;
    currentServingData = null;

    setLoadingState();

    fetchServingData(handle).then(function (result) {
      /*
       * Prevent a slow earlier request from changing the
       * popup after the customer has selected another product.
       */
      if (handle !== currentProductHandle) {
        return;
      }

      if (!result.servingData) {
        setUnavailableState(result.productText);
        return;
      }

      buildServingOptions(result.servingData);
    });
  }

  function updateLabels() {
    const customizeArea = document.getElementById(
      'pack-customize-area'
    );

    if (!customizeArea) return;

    const quantityLabel = customizeArea.querySelector(
      'label[for="pack-quantity"]'
    );

    const note = customizeArea.querySelector(
      '.pack-customize-note'
    );

    if (quantityLabel) {
      quantityLabel.textContent =
        'How many servings would you like?';
    }

    if (note) {
      note.textContent =
        'The recommended serving is selected by default. Choose a larger amount only when needed.';
    }
  }

  /*
   * Capture the product handle before the existing Algolia
   * Add to Pack code opens the pack popup.
   */
  document.addEventListener(
    'click',
    function (event) {
      const addButton = event.target.closest(
        '#algolia-shopify-instantsearch .ais-hit--cart-button'
      );

      if (!addButton) return;

      const handle =
        getHandleFromAlgoliaButton(addButton);

      if (!handle) {
        console.warn(
          'SuppLovin: No product handle found on the Algolia result card.'
        );
        return;
      }

      currentProductHandle = handle;
      currentServingData = null;

      /*
       * Remove an earlier failed result so the product page
       * and its latest metafields are fetched again.
       */
      delete servingCache[handle];
    },
    true
  );

  /*
   * Capture the current product when Add to Pack is used
   * from an individual Shopify product page.
   */
  document.addEventListener(
    'submit',
    function (event) {
      const formElement = event.target;

      if (
        !formElement.matches(
          'product-form form, form[action*="/cart/add"]'
        )
      ) {
        return;
      }

      const handle = getHandleFromProductPage();

      if (handle) {
        currentProductHandle = handle;
      }
    },
    true
  );

  /*
   * Load the serving metafields when Customize is clicked.
   * On Algolia/search pages, identify the exact product by
   * matching the open popup text to the visible result cards.
   */
  document.addEventListener(
    'click',
    function (event) {
      const customizeButton = event.target.closest(
        '#pack-customize'
      );

      if (!customizeButton) return;

      updateLabels();

      const productPageHandle =
        getHandleFromProductPage();

      if (productPageHandle) {
        delete servingCache[productPageHandle];
        loadServingOptions(productPageHandle);
        return;
      }

      const modal =
        document.querySelector('#pack-modal') ||
        document.querySelector('.pack-modal');

      const modalText = String(
        modal ? modal.innerText : ''
      )
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

      const cards = Array.from(
        document.querySelectorAll(
          '.ais-hit[data-handle]'
        )
      );

      const matches = cards
        .map(function (card) {
          const handle = String(
            card.getAttribute('data-handle') || ''
          ).trim();

          const cardText = String(
            card.innerText || ''
          )
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, ' ')
            .trim();

          const words = modalText
            .split(' ')
            .filter(function (word) {
              return word.length > 2;
            });

          const score = words.filter(function (word) {
            return cardText.includes(word);
          }).length;

          return {
            handle: handle,
            score: score
          };
        })
        .filter(function (item) {
          return item.handle;
        })
        .sort(function (a, b) {
          return b.score - a.score;
        });

      const selected = matches[0];

      if (!selected || !selected.handle) {
        setUnavailableState(modalText);
        return;
      }

      currentProductHandle = selected.handle;
      currentServingData = null;

      delete servingCache[selected.handle];

      setLoadingState();

      fetchServingData(selected.handle).then(
        function (result) {
          if (
            selected.handle !==
            currentProductHandle
          ) {
            return;
          }

          if (!result || !result.servingData) {
            setUnavailableState(
              result && result.productText
                ? result.productText
                : modalText
            );
            return;
          }

          buildServingOptions(result.servingData);
        }
      );
    }
  );

  /*
   * Add readable serving details as Shopify line-item
   * properties while preserving the existing Pack Quantity.
   */
  document.addEventListener(
    'click',
    function (event) {
      const confirmButton = event.target.closest(
        '#confirm-pack-add'
      );

      if (!confirmButton) return;

      const select = document.getElementById(
        'pack-quantity'
      );

      if (
        !select ||
        !select.value ||
        !currentServingData
      ) {
        return;
      }

      const selectedOption =
        select.options[select.selectedIndex];

      const servings =
        selectedOption &&
        selectedOption.dataset.servings
          ? selectedOption.dataset.servings
          : '';

      const pieces =
        selectedOption &&
        selectedOption.dataset.pieces
          ? selectedOption.dataset.pieces
          : select.value;

      const dosageForm =
        currentServingData.form || 'piece';

      const formsToUpdate = [];

      if (window.pendingPdpForm) {
        formsToUpdate.push(window.pendingPdpForm);
      }

      document
        .querySelectorAll(
          'form[action*="/cart/add"], product-form form'
        )
        .forEach(function (formElement) {
          formsToUpdate.push(formElement);
        });

      /*
       * Remove duplicate form references.
       */
      const uniqueForms = Array.from(
        new Set(formsToUpdate)
      );

      uniqueForms.forEach(function (formElement) {
        if (!formElement) return;

        formElement
          .querySelectorAll(
            '[name="properties[Selected Servings]"],' +
            '[name="properties[Pieces Per Serving]"],' +
            '[name="properties[Serving Selection]"]'
          )
          .forEach(function (input) {
            input.remove();
          });

        const selectedServingsInput =
          document.createElement('input');

        selectedServingsInput.type = 'hidden';
        selectedServingsInput.name =
          'properties[Selected Servings]';

        selectedServingsInput.value =
          servings +
          (servings === '1'
            ? ' serving'
            : ' servings');

        formElement.appendChild(
          selectedServingsInput
        );

        const piecesPerServingInput =
          document.createElement('input');

        piecesPerServingInput.type = 'hidden';
        piecesPerServingInput.name =
          'properties[Pieces Per Serving]';

        piecesPerServingInput.value =
          currentServingData.piecesPerServing +
          ' ' +
          pluralizeForm(
            dosageForm,
            currentServingData.piecesPerServing
          );

        formElement.appendChild(
          piecesPerServingInput
        );

        const servingSelectionInput =
          document.createElement('input');

        servingSelectionInput.type = 'hidden';
        servingSelectionInput.name =
          'properties[Serving Selection]';

        servingSelectionInput.value =
          servings +
          (servings === '1'
            ? ' serving'
            : ' servings') +
          ' — ' +
          pieces +
          ' ' +
          pluralizeForm(dosageForm, pieces);

        formElement.appendChild(
          servingSelectionInput
        );
      });
    },
    true
  );

  const style = document.createElement('style');

  style.textContent = `
    .pack-serving-message {
      display: flex;
      flex-direction: column;
      gap: 5px;
      margin: 0 0 16px;
      padding: 13px 14px;
      border: 1px solid #b9d9d5;
      border-radius: 12px;
      background: #f2faf9;
      color: #253047;
    }

    .pack-serving-message strong {
      color: #147b74;
      font-size: 15px;
      line-height: 1.4;
    }

    .pack-serving-message span {
      color: #667085;
      font-size: 12px;
      line-height: 1.5;
    }

    #pack-quantity:disabled {
      cursor: wait;
      opacity: 0.7;
    }
  `;

  document.head.appendChild(style);
});
